import React from 'react';
import PropTypes from 'prop-types';
import { sinceYears } from '../../../fund/fund-components/shared-utils';
import { useIsLarge } from '../../../../shared/theme';
import MonetaryDataFact from './monetary-data-fact';
import PercentageDataFact from './percentage-data-fact';

export default function Summary(props) {
  const {
    inceptionDate,
    minimumInvestment,
    managementFee,
    returnSinceInception,
  } = props;

  const minInvestmentLabel = `${useIsLarge() ? 'Minimum' : 'Min'} Investment`;

  return (
    <>
      <MonetaryDataFact
        label={minInvestmentLabel}
        value={minimumInvestment}
        nullReplacement="N/A"
        clazz="first"
      />
      <PercentageDataFact
        label="Management Fee"
        value={managementFee}
        nullReplacement="N/A"
        perAnnual
      />
      <PercentageDataFact
        label="Growth Since Inception"
        value={returnSinceInception}
        nullReplacement="-"
        perAnnual
        date={sinceYears(inceptionDate)}
        clazz="last"
      />
    </>
  );
}

Summary.propTypes = {
  inceptionDate: PropTypes.string.isRequired,
  minimumInvestment: PropTypes.number,
  managementFee: PropTypes.string,
  returnSinceInception: PropTypes.string.isRequired,
};

Summary.defaultProps = {
  managementFee: null,
  minimumInvestment: null,
};
